import { render, staticRenderFns } from "./AffiliateInvitationsCard.vue?vue&type=template&id=44adf69a&"
import script from "./AffiliateInvitationsCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateInvitationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports